import { ApolloClient, InMemoryCache, createHttpLink  } from '@apollo/client';
import { SetContextLink } from '@apollo/client/link/context';

const httpLink = createHttpLink({
    uri: `${process.env.REACT_APP_BASE_URL_PUBLISH}/api/pubs/graphql`,
  });

// VIVA-992 (VN-04): el gateway/microservicio ahora exigen JWT en /api/pubs/graphql — mismo patrón
// que ya usan las instancias Axios (AxiosInstance.js): token de localStorage, header Authorization Bearer.
const authLink = new SetContextLink((prevContext) => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      ...prevContext.headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
});

  export const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: 'network-only',
      },
    },
  });